// When the deal header's overflow menu offers an item. Each rule mirrors the
// server so the menu never offers an action that is refused (staging run,
// 2026-10-14: Decline and Mark withdrawn answered 400 on a Closed deal).

import type { DealPipelineStage } from "@/types/deals";

/** Mirrors DealStageMachine.IsTerminal. Decline, Withdraw and the escrow
 *  draft are refused on these stages, for an ADMIN too. */
export function isTerminalStage(stage: DealPipelineStage): boolean {
  return stage === "Closed" || stage === "Declined" || stage === "Withdrawn";
}

interface DealLockOptions {
  stage: DealPipelineStage;
  declineStatus: string;
  canReopenClosedDeal: boolean;
  /** DealFlow.EditWithdrawnOrDeclinedDeal, which only ADMIN holds. */
  canEditWithdrawnOrDeclinedDeal: boolean;
}

/** ClosedDealReadOnlyMiddleware: 423 on a Closed deal unless the caller holds
 *  DealFlow.ReopenClosedDeal. */
function passesClosedDealLock(options: DealLockOptions): boolean {
  return options.stage !== "Closed" || options.canReopenClosedDeal;
}

/** Whether Archive or Restore gets past the read-only middlewares: the Closed
 *  lock and DeclinedDealReadOnlyMiddleware (422 once a decline is ratified,
 *  except archive and restore by a holder of DealFlow.EditWithdrawnOrDeclinedDeal,
 *  that is ADMIN; owner ruling, 2026-10-26). WithdrawnOrDeclinedDealReadOnlyMiddleware
 *  exempts both (owner ruling, 2026-10-15). */
export function canArchiveOrRestoreDeal(options: DealLockOptions): boolean {
  return (
    passesClosedDealLock(options) &&
    (options.declineStatus !== "Declined" || options.canEditWithdrawnOrDeclinedDeal)
  );
}

/** Whether any other write under /api/deals/{id}/ (Reassign, the assignment
 *  pills, Mark withdrawn) gets past all three locks: the Closed lock, the
 *  ratified-decline lock (which refuses these for ADMIN too) and
 *  WithdrawnOrDeclinedDealReadOnlyMiddleware (423 on a Withdrawn or
 *  stage-Declined deal unless the caller holds
 *  DealFlow.EditWithdrawnOrDeclinedDeal, which only ADMIN does). */
export function canWriteToDeal(options: DealLockOptions): boolean {
  return (
    passesClosedDealLock(options) &&
    options.declineStatus !== "Declined" &&
    ((options.stage !== "Withdrawn" && options.stage !== "Declined") ||
      options.canEditWithdrawnOrDeclinedDeal)
  );
}
